import { createTheme } from "../utils/create-theme";
export var SPORT_THEME = createTheme('sport', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#98BF10',
      primaryDarker: '#5b730a',
      primaryLight: '#e0ecb7',
      primaryLighter: '#b7d258',
      primaryBright: '#94BE09',
      primaryVeryLight: '#ecf4d4',
      textTitle: '#666',
      link: '#98BF10',
      linkHover: '#000',
      navigationActive: '#98BF10',
      accentDark: '#5b730a',
      accentLight: '#e0ecb7'
    }
  },
  dark: {
    color: {
      linkHover: '#53aeaa'
    }
  }
});
export default SPORT_THEME;